import { OneTrustModule } from '@altack/ngx-onetrust';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { inject, InjectionToken, NgModule, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { KbAuthHttpHeaderService } from './services/feature/kb-auth-http-header.service';
import {
  AuthHttpHeaderService,
  BASE_SITE_CONTEXT_ID,
  BasePageMetaResolver,
  CmsConfig,
  CONFIG_INITIALIZER,
  ConfigInitializer,
  ConfigModule,
  ContentPageMetaResolver,
  Converter,
  I18nModule,
  OccProductSearchPageNormalizer,
  PageMetaService,
  ProductAdapter,
  ProductNameNormalizer,
  provideDefaultConfigFactory,
  SearchPageMetaResolver,
  SiteContextConfig
} from '@spartacus/core';
import { OrderConfirmationGuard } from '@spartacus/order/components';
import { AppRoutingModule, CarouselModule, CurrentProductService, FacetService, ProductListComponentService, LogoutGuard } from '@spartacus/storefront';
//import { WebtrekkSmartPixelModule } from '@webtrekk-smart-pixel/angular';
import { AsmAuthService } from '@spartacus/asm/root';
import { OccCartNormalizer } from '@spartacus/cart/base/occ';
import { USER_ACCOUNT_NORMALIZER } from '@spartacus/user/account/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AppComponent } from './app.component';
import { CountrySelectorService } from './customServices/country-selector.service';
import { FacetKbService } from './customServices/facet-kb.service';
import { CategoryPageModule } from './customcomponents/category-page/category-page.module';
import { FacetNavigationModule } from './customcomponents/facet-navigation/facet-navigation.module';
import { FooterModule } from './customcomponents/footer/footer.module';
import { HeaderModule } from './customcomponents/header/header.module';
import { KbCheckoutModule } from './customcomponents/kb-Checkout/kb-checkout.module';
import { KbCountryFlagModule } from './customcomponents/kb-country-flag/kb-country-flag/kb-country-flag.module';
import { KbDataExtractionRequestModule } from './customcomponents/kb-data-extraction-request/kb-data-extraction-request.module';
import { KbDemoRegistrationModule } from './customcomponents/kb-demo-registration/kb-demo-registration.module';
import { KbHeaderLanguageModule } from './customcomponents/kb-header-language/kb-header-language.module';
import { KbLoginModule } from './customcomponents/kb-login/Kb-Login.module';
import { updatePasswordModule } from './customcomponents/kb-login/update-password/update-password.module';
import { MiniCartModule } from './customcomponents/kb-mini-cart/mini-cart.module';
import { KbImportOrderModule } from './customcomponents/kb-mini-cart/quick-order-nav/kb-importorder/kb-importorder.module';
import { QuickOrderFormModule } from './customcomponents/kb-mini-cart/quick-order-nav/kb-quickorderform/kb-quickorderform.module';
import { QuickOrderNavModule } from './customcomponents/kb-mini-cart/quick-order-nav/quick-order-nav.module';
import { KbBrakeApplicationFormsModule } from './customcomponents/kb-myAccount/kb-Brake-Applications/kbBrakeApllicationForms-module/kbBrakeApllicationForms-module.module';
import { KbMyAccountModule } from './customcomponents/kb-myAccount/kb-my-account.module';
import { KbParagraphModule } from './customcomponents/kb-paragraph/kb-paragraph.module';
import { KbProductCategoriesModule } from './customcomponents/kb-product-categories/kb-product-categories.module';
import { AddedToCartDialogModule } from './customcomponents/kb-product-list/added-to-cartdialog/added-to-cart-dialog.module';
import { CompareModule } from './customcomponents/kb-product-list/kb-compare/kb-compare-module.module';
import { KbRotatingBannerModule } from './customcomponents/kb-rotating-banner/kb-rotating-banner.module';
import { KbWarrantyModule } from './customcomponents/kb-warranty/kb-warranty.module';
import { KbLoaderModule } from './customcomponents/loader/loader.module';
import { SearchBarModule } from './customcomponents/search-bar/search-bar.module';
import { contextInitializerProviders } from './customcomponents/site-context-selector/context-initializer-providers';
import { contextServiceMapProvider } from './customcomponents/site-context-selector/context-service-map';
import { defaultSiteContextConfigFactory } from './customcomponents/site-context-selector/defaultSiteContextConfigFactory';
import { SiteContextConfigInitializer } from './customcomponents/site-context-selector/site-context-config-initializer';
import { SiteContextStoreModule } from './customcomponents/site-context-selector/site-context-store.module';
import { TechTeamModule } from './customcomponents/tech-team/tech-team.module';
import { KbOrderConfirmationGuard } from './services/Guards/orderConfirmation/orderConfirmation.service';
import { kbOneTrustInitService } from './services/OneTrust/oneTrust.service';
import { appInitializer } from './services/OneTrust/oneTrustAppInitializer';
import { KbAuthService } from './services/feature/auth.service';
import { KbCurrentProductService } from './services/feature/kb-current-product.service';
import { KBPageMetaService } from './services/feature/kb-page-meta.service';
import { KbProductListComponentServiceService } from './services/feature/kb-product-list-component-service.service';
import { KbSearchPageMetaResolver } from './services/feature/kbSearchPageMetaResolver.resolver';
import { HttpAsmCustomerIdInterceptor } from './services/interceptor/http-asm-customer-id.interceptor';
import { HttpAsmSsoInterceptor } from './services/interceptor/http-asm-sso.interceptor';
import { HttpBreadCrumbInterceptor } from './services/interceptor/http-breadcrumb.interceptor';
import { HttpStoreInterceptor } from './services/interceptor/http-store.interceptor';
import { KbHttpErrorInterceptor } from './services/interceptor/kb-http-error-interceptor';
import { LoadingInterceptor } from './services/interceptor/loading.interceptor';
import { KbCatgegoryUrlNormalizer } from './services/pageNormalizer/kb-category-url.normalizer';
import { kbOccCartNormalizer } from './services/pageNormalizer/kb-occ-cart-page-normalizer';
import { KbOccProductAdapter } from './services/pageNormalizer/kb-occ-product.adapter';
import { kbOccProductSearchPageNormalizer } from './services/pageNormalizer/kb-ooc-search-page-normalizer';
import { kbProductNameNormalizer } from './services/pageNormalizer/kb-product-name.normalizer';
import { KbProductUrlNormalizer } from './services/pageNormalizer/kb-product-url.normalizer';
import { KbUserAccountNormalizer } from './services/pageNormalizer/kb-user-account-normalizer';
import { KbContentPageMetaResolver } from './services/sapSpartacus/pageMetaResolver/kb-content-page-meta.resolver';
import { KbPageTitleService } from './services/sapSpartacus/pageMetaResolver/kb-page-title.service';
import { SpartacusModule } from './spartacus/spartacus.module';
import { SSRHttpDebugInterceptor } from './SSRHttpDebugInterceptor';
import { CxaiAssistantFeatureModule } from '@cx-spartacus/cxai-assistant/feature';
import { CxaiAssistantRootModule } from '@cx-spartacus/cxai-assistant/root';
import { CustomLogoutGuard } from './custom-logout.guard';
export const KB_PRODUCT_URL_NORMALIZER = new InjectionToken<Converter<any, any>>('KbProductUrlNormalizer');
export const KB_CATEGORY_NORMALIZER = new InjectionToken<Converter<any, any>>('KbCatgegoryUrlNormalizer');
export function initSiteContextConfig(
  configInitializer: ConfigInitializer,
  config: SiteContextConfig
): ConfigInitializer | null {
  if (!config.context || !config.context[BASE_SITE_CONTEXT_ID]) {
    return configInitializer as ConfigInitializer;
  }
  return null;
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    OneTrustModule.forRoot({
      cookiesGroups: {
        StrictlyNecessaryCookies: 'C0001',
        PerformanceCookies: 'C0002',
        FunctionalCookies: 'C0003',
        TargetingCookies: 'C0004',
        SocialMediaCookies: 'C0005',
      },
    }),
    BrowserModule,
    HttpClientModule,
    LoggerModule.forRoot({
      serverLoggingUrl: '',
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.TRACE
    }),
    AppRoutingModule,
    RouterModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    HeaderModule,
    FooterModule,
    KbParagraphModule,
    CarouselModule,
    KbProductCategoriesModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    KbLoginModule,
    KbHeaderLanguageModule,
    KbCountryFlagModule,
    updatePasswordModule,
    KbRotatingBannerModule,
    SlickCarouselModule,
    CategoryPageModule,
    FacetNavigationModule,
    SearchBarModule,
    MiniCartModule,
    QuickOrderNavModule,
    CompareModule,
    AddedToCartDialogModule,
    KbLoaderModule,
    KbCheckoutModule,
    KbImportOrderModule,
    QuickOrderFormModule,
    KbMyAccountModule,
    KbWarrantyModule,
    TabsModule,
    AccordionModule,
    BsDatepickerModule,
    SiteContextStoreModule,
    KbBrakeApplicationFormsModule,
    I18nModule,
    TechTeamModule,
    KbDemoRegistrationModule,
    KbDataExtractionRequestModule,
    ConfigModule.withConfig(<CmsConfig>{
      skipLinks: [],
    }),
    CxaiAssistantFeatureModule,
    CxaiAssistantRootModule
  ],
  providers: [
    provideHttpClient(withFetch()),
    provideDefaultConfigFactory(defaultSiteContextConfigFactory),
    ...contextInitializerProviders,
    contextServiceMapProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KbHttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpStoreInterceptor,
      multi: true,
    },
    {
      provide: LogoutGuard,
      useClass: CustomLogoutGuard,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAsmSsoInterceptor,
      multi: true,
    },
    {
      provide: BasePageMetaResolver,
      useClass: KbPageTitleService,
    },
    {
      provide: OccProductSearchPageNormalizer,
      useClass: kbOccProductSearchPageNormalizer,
    },
    {
      provide: OrderConfirmationGuard,
      useClass: KbOrderConfirmationGuard,
    },
    {
      provide: PageMetaService,
      useClass: KBPageMetaService,
    },
    {
      provide: SearchPageMetaResolver,
      useClass: KbSearchPageMetaResolver,
    },
    {
      provide: AsmAuthService,
      useExisting: KbAuthService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SSRHttpDebugInterceptor,
      multi: true
    },
    provideAppInitializer(() => {
      const initializerFn = (appInitializer)(inject(kbOneTrustInitService));
      return initializerFn();
    }),
    {
      provide: CONFIG_INITIALIZER,
      useFactory: initSiteContextConfig,
      deps: [SiteContextConfigInitializer, SiteContextConfig],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAsmCustomerIdInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpBreadCrumbInterceptor,
      multi: true,
    },
    {
      provide: USER_ACCOUNT_NORMALIZER,
      useClass: KbUserAccountNormalizer,
      multi: true,
    },
    {
      provide: ProductAdapter,
      useClass: KbOccProductAdapter,
    },
    {
      provide: ContentPageMetaResolver,
      useClass: KbContentPageMetaResolver,
    },
    {
      provide: FacetService,
      useClass: FacetKbService,
    },
    {
      provide: ProductListComponentService,
      useClass: KbProductListComponentServiceService,
    },
    {
      provide: CurrentProductService,
      useExisting: KbCurrentProductService,
    },
    {
      provide: KB_CATEGORY_NORMALIZER,
      useExisting: KbCatgegoryUrlNormalizer,
      multi: true,
    },
    {
      provide: KB_PRODUCT_URL_NORMALIZER,
      useExisting: KbProductUrlNormalizer,
      multi: true,
    },
    {
      provide: OccCartNormalizer,
      useClass: kbOccCartNormalizer,
    },
    {
      provide: ProductNameNormalizer,
      useClass: kbProductNameNormalizer,
    },
    {
      provide: AuthHttpHeaderService,
      useExisting: KbAuthHttpHeaderService
    },
    CountrySelectorService,
    provideHttpClient(withInterceptorsFromDi()),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true })
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
